module.exports = __webpack_public_path__ + "img/fastmoney.71562d16.svg";